import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

// Assets
import wavesImage from "../../assets/png/wavesEvent.png";
// import humanFaceScanning from "../../assets/png/Human face scanning.png";
import humanFaceScanning from "../../assets/png/face-scanning.png";

//CSS
import styles from "./UserRegistration.module.css";

// MUI
import { Box } from "@mui/material";

// JDS
import { Button, Container, Text } from "@jds/core";

// Local
import EventRegistrationPrimaryBtn from "../../components/UI/EventRegistrationPrimaryBtn/EventRegistrationPrimaryBtn";
import EventRegistrationSecondaryBtn from "../../components/UI/EventRegistrationSecondaryBtn/EventRegistrationSecondaryBtn";
import { setSelfieModalClose } from "../../store/state-slices/userRegistration";
import { LazyLoadImage } from "react-lazy-load-image-component";
import decryptUrl from "../../util/img-decryption";
import { optionalFaceDetectionIdList } from "../../util/helper";
import useApiHttp from "../../hooks/use-http";
import PageLoader from "../../components/UI/Loader/PageLoader";
import { authActions } from "../../store/state-slices/auth";
const UserRegistration = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const params = new URLSearchParams(useLocation().search);
  const eventId = params.get("eventId");

  const bannerThumbnailURl = localStorage?.bannerThumbnailURl
    ? decryptUrl(localStorage?.bannerThumbnailURl)
    : "";
  const isRegisteredAlready = localStorage.isRegisteredAlready === "true";
  const [firstName, setFirstName] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);
  const { sendRequest: getProfileDetails, isLoading: isProfileLoading } =
    useApiHttp();

  let content = <></>;

  content = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        alignItems: "center",
      }}
    >
      <Container>
        <Text
          text={`Welcome ${firstName ? firstName : ""}`}
          appearance="heading-xs"
          textAlign="center"
        />
      </Container>

      <Container style={{ padding: "0 24px" }}>
        <Text
          text="We’ll identify your face in event photos and automatically create a personalized album for easy access."
          appearance="body-xs"
          textAlign="center"
        />
      </Container>
      <img
        src={humanFaceScanning}
        style={{ width: "120px", height: "120px" }}
      />
    </div>
  );

  // if (!isRegisteredAlready) {
  //   content = (
  //     <div
  //       style={{
  //         display: "flex",
  //         flexDirection: "column",
  //         gap: "32px",
  //         alignItems: "center",
  //       }}
  //     >
  //       <Container>
  //         <Text
  //           text={`Welcome ${firstName ? firstName : ''}`}
  //           appearance="heading-s"
  //           textAlign="center"
  //         />
  //       </Container>

  //       <Container style={{ padding: '0 24px' }}>
  //         <Text
  //           text="We will identify your face in Waves event photos and will automatically create an album for easy access."
  //           appearance="body-s"
  //           textAlign="center"
  //         />
  //       </Container>
  //       <img
  //         src={humanFaceScanning}
  //         style={{ width: "120px", height: "120px" }}
  //       />
  //     </div>
  //   );
  // }
  // if (!isProfilePictureThumbnail && isRegisteredAlready) {
  //   // if (1) {
  //   content = (
  //     <div
  //       style={{
  //         display: "flex",
  //         flexDirection: "column",
  //         gap: "16px",
  //         alignItems: "center",
  //         height: "inherit%",
  //         // height: "calc(100vh - 340px)",
  //       }}
  //     >
  //       <Container>
  //         <Text
  //           text="Already registered"
  //           appearance="heading-s"
  //           color="white"
  //           textAlign="center"
  //         />
  //       </Container>
  //       <img
  //         src={humanFaceScanning}
  //         style={{ width: "120px", height: "120px" }}
  //       />
  //       <Text
  //         text="Just click and upload a selfie! "
  //         color="white"
  //         appearance="body-m-bold"
  //         textAlign="center"
  //       />
  //       <Container style={{ padding: '0 8px' }}>
  //         <Text
  //           text="JioAICloud identifies your face in Waves event photos and auto-creates an album for easy access."
  //           color="white"
  //           appearance="body-s"
  //           textAlign="center"
  //         />
  //       </Container>
  //     </div>
  //   );
  // }
  // if (isProfilePictureThumbnail && isRegisteredAlready) {
  //   // if (0) {
  //   content = (
  //     <>
  //       <div
  //         style={{
  //           width: "38vh",
  //           display: "flex",
  //           flexDirection: "column",
  //           gap: "32px",
  //           alignItems: "center",
  //           height: "270px",
  //         }}
  //       >
  //         <Container>
  //           <Text
  //             text="You are already registered"
  //             appearance="heading-s"
  //             color="white"
  //             textAlign="center"
  //           />
  //         </Container>
  //         <Container>
  //           <Text
  //             text="See your photos from the WAVES event. Just tap the button below."
  //             color="white"
  //             appearance="body-m-bold"
  //             textAlign="center"
  //           />
  //         </Container>
  //       </div>
  //     </>
  //   );
  // }

  useEffect(() => {
    getProfileDetails(
      {
        base: "AUTH",
        url: `profile`,
        method: "GET",
      },
      null,
      (data) => {
        setFirstName(data?.data?.firstName);
      },
      (_, err) => { }
    );
  }, []);

  return (
    <>
      <div
        style={
          {
            // backgroundColor: "#54086E",
            // height: "calc(100vh - 50px)",
          }
        }
        className={styles["user-registration__card"]}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            aspectRatio: "16 / 9",
            overflow: "hidden",
            "& .j-JDSSkeleton-container ": {
              borderRadius: 0,
            },
          }}
        >
          {bannerThumbnailURl && (
            <img
              src={bannerThumbnailURl}
              alt="blurred-banner"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                filter: "blur(20px)",
                transform: "scale(1.05)",
                position: "absolute",
                top: 0,
                left: 0,
                transition: "opacity 0.3s ease-in-out",
                opacity: imageLoaded ? 0 : 1,
                zIndex: 2,
              }}
            />
          )}

          {bannerThumbnailURl && (
            <LazyLoadImage
              src={bannerThumbnailURl}
              alt="event banner"
              afterLoad={() => setImageLoaded(true)}
              width="100%"
              height="100%"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "absolute",
                top: 0,
                left: 0,
                opacity: imageLoaded ? 1 : 0,
                transition: "opacity 0.6s ease-in-out",
                zIndex: 3,
              }}
            />
          )}
        </Box>

        <div
          style={{
            // padding: "32px 24px",
            paddingTop: "24px",
            // height: "calc(100vh - 331px)",
          }}
        >
          {/* {!isProfilePictureThumbnail && !isRegisteredAlready && (
            <UserStatus content={content} photosNavigation={false} />
          )}
          {isProfilePictureThumbnail && !isRegisteredAlready && (
            <UserStatus content={content} photosNavigation={true} />
          )}
          {!isProfilePictureThumbnail && isRegisteredAlready && (
            <UserStatus content={content} photosNavigation={false} />
          )}
          {isProfilePictureThumbnail && isRegisteredAlready && (
            <UserStatus content={content} photosNavigation={true} />
          )} */}
          <UserStatus content={content} photosNavigation={false} />
        </div>
      </div>
      <Box>{isProfileLoading && <PageLoader open={isProfileLoading} />}</Box>
    </>
  );
};

export default UserRegistration;

const UserStatus = ({ content, photosNavigation = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "space-around",
        position: "relative",
      }}
    >
      <div>{content}</div>
      {/* <div style={{ position: "absolute", bottom: "10%" }}> */}
      <Box
        sx={{
          padding: "56px 24px",
          width: "100%",
          "@media screen and (max-width: 575px)": {
            padding: "0 24px",
            position: "fixed",
            bottom: "24px",
          },
        }}
      >
        {photosNavigation ? (
          <EventRegistrationSecondaryBtn
            onClick={() => {
              navigate("/user-registered/photos");
            }}
            sx={{ mt: "32px" }}
            fullWidth
          >
            Go to My photos
          </EventRegistrationSecondaryBtn>
        ) : (
          <Button
            fullWidth
            onClick={() => {
              dispatch(setSelfieModalClose(false));
            }}
          >
            Click selfie
          </Button>
        )}
      </Box>
    </div>
  );
};
// const RegisteredSuccessfullyComponent = () => {
//   const isRegisteredAlready = localStorage.isRegisteredAlready;
//   const firstName = localStorage.firstName;
//   const lastName = localStorage.lastName;
//   const dispatch = useDispatch();

//   return (
//     <>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           flexDirection: "column",
//           justifyContent: "center",
//         }}
//       >
//         {isRegisteredAlready === "true" ? (
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "32px",
//               alignItems: "center",
//             }}
//           >
//             <Container>
//               <Text
//                 text="Registered successfully"
//                 appearance="heading-s"
//                 color="white"
//                 textAlign="center"
//               />
//             </Container>
//             <img
//               src={humanFaceScanning}
//               style={{ width: "120px", height: "120px" }}
//             />
//             <Text
//               text="Just click and upload a selfie! "
//               color="white"
//               appearance="body-m-bold"
//               textAlign="center"
//             />
//             <Container>
//               <Text
//                 text="JioAICloud identifies your face in Waves event photos and auto-creates an album for easy access."
//                 color="white"
//                 appearance="body-s"
//                 textAlign="center"
//               />
//             </Container>
//             <EventRegistrationSecondaryBtn
//               fullWidth
//               sx={{ mt: "24px" }}
//               onClick={() => {
//                 dispatch(setSelfieModalClose(false));
//               }}
//             >
//               Upload selfie
//             </EventRegistrationSecondaryBtn>
//           </div>
//         ) : (
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "32px",
//               alignItems: "center",
//             }}
//           >
//             <Container>
//               <Text
//                 text={`Welcome ${firstName}`}
//                 appearance="heading-s"
//                 color="white"
//                 textAlign="center"
//               />
//             </Container>

//             <Container>
//               <Text
//                 text="We will identify your face in Waves event photos and will automatically create an album for easy access."
//                 color="white"
//                 appearance="body-s"
//                 textAlign="center"
//               />
//             </Container>
//             <img
//               src={humanFaceScanning}
//               style={{ width: "120px", height: "120px" }}
//             />

//             <EventRegistrationSecondaryBtn
//               fullWidth
//               sx={{ mt: "24px" }}
//               onClick={() => {
//                 dispatch(setSelfieModalClose(false));
//               }}
//             >
//               Upload selfie
//             </EventRegistrationSecondaryBtn>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// const AlreadyRegisteredComp = () => {
//   const navigate = useNavigate();
//   return (
//     <>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           flexDirection: "column",
//           justifyContent: "center",
//         }}
//       >
//         <div
//           style={{
//             width: "38vh",
//             display: "flex",
//             flexDirection: "column",
//             gap: "32px",
//             alignItems: "center",
//             height: "45vh",
//           }}
//         >
//           <Container>
//             <Text
//               text="You are already registered"
//               appearance="heading-s"
//               color="white"
//               textAlign="center"
//             />
//           </Container>
//           <Container>
//             <Text
//               text="See your photos from the WAVES event. Just tap the button below."
//               color="white"
//               appearance="body-m-bold"
//               textAlign="center"
//             />
//           </Container>
//         </div>
//         <Container paddingTop={5} fullWidth>
//           <EventRegistrationSecondaryBtn
//             onClick={() => {
//               navigate("/user-registered/photos");
//             }}
//             fullWidth
//           >
//             Go to My photos
//           </EventRegistrationSecondaryBtn>
//         </Container>
//       </div>
//     </>
//   );
// };
